import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import scrollGridPlugin from "@fullcalendar/scrollgrid";
import itLocale from "@fullcalendar/core/locales/it";
import "../../../css/calendar.css";
import { Box, Tooltip } from "@mui/material";
import "../../../css/calendar.css";
import doctorImage from "../../../assets/Avatar=Medico 1.svg";
import doctorImage2 from "../../../assets/Avatar=Medico 2.svg";
import {
  bookSlot,
  manageAppointment,
  pacomb,
  panoteg,
  paraggr,
  wPacomb,
  wParaggr,
} from "../../../networking";
import ModalReservation, { Patient } from "./ModalReservation/ModalReservation";
import dayjs from "dayjs";
import { ModalReservationSummaryNew } from "./ModalReservation/ModalSummary/ModalReservationSummary";
import DoctorCard from "./DoctorCard/DoctorCard";
import {
  ClassePriorita,
  Enti,
  ModalitaSospesi,
  PosizioneTicket,
} from "../AppointmentManagement";
import { DataContext } from "./Context/ContextWrapper";
import { FormatGrigliaOrariPerGestioneSospesi } from "../../../services/gestioneSospesi";
import { AllertMessage } from "../../DoctorsList/Medint/MedintDetails/MedintDetails";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import OptionsMenu from "./OptionsMenu";
import { DailyNoteOption } from "./DailyNoteOption";
import { DailyUnavailability } from "./DailyUnavailability";
import GroupableProcedures from "./GroupableProcedures/GroupableProcedures";
import CombinedProcedures, {
  CombinedProceduresRow,
} from "./GroupableProcedures/CombinedProcedures";

type DoctorNote = {
  id: string;
  medico: string;
  nominativo?: string;
  data: string;
  testo: string;
};

export type GroupableProcedureRow = {
  id: string;
  specialita: string;
  prestazione: string;
  codSiss: string;
  descrizioneSiss: string;
  qta: number;
  valDa: number | string;
  valAl: number | string;
  ntr: string;
};

type CalendarEvent = {
  noteCan?: any;
  notePren?: any;
  title: string;
  start: string;
  medicoId: string;
  nominativoMedico: string;
  struttura: string;
  sede: string;
  sedeIndirizzo: string;
  tariffa: string;
  durata: string;
  genere?: string;
  specialita?: string;
  prestazione?: string;
  data?: string;
  ora?: string;
  tipoAgenda?: string;
  codiceOperatore?: string;
  medico?: string;
  importo?: string;
  primaDisponibilita?: string;
  agenda?: string;
  tipologiaAgenda?: string;
  selectedDate?: string;
  durataPrestazione?: string;
  descrizionePrestazione?: string;
  descrizioneSpecialita?: string;
  descrizioneTipoAgenda?: string;
  noteSettimana?: any;
  notaMedico?: string;
  flagOrarioGiornaliero?: string;
};

export type CalendarItem = {
  medicoId?: string;
  nominativoMedico?: string;
  struttura?: string;
  agenda?: string;
  tipoAgenda?: string;
  tipologiaAgenda?: string;
};

export type CalendarInfo = {
  medico: string[];
  codiceMedico?: string;
  idMedico?: string;
  aziendaPrenotazione?: string;
  agenda?: string;
  tipologia?: string;
  tipologiaDescrizione?: string;
  dataSelezionata?: string;
};

export interface CodicePostic {
  CODICEPOSTIC: string;
  RICERCAPOSTIC: string;
  SELEZIONATO: string;
  TIPOCALCOLO: string;
}

// custom hook per dei valori chiavi della componente che saranno necessari
export function useCalendarInfo(calendarData: CalendarItem[]): CalendarInfo {
  return useMemo(() => {
    const medico: string[] = Array.from(
      new Set(
        calendarData
          .filter((e) => e.medicoId && e.nominativoMedico)
          .map((e) => `[${e.medicoId}] - ${e.nominativoMedico}`)
      )
    );

    const firstItem = calendarData[0];

    return {
      medico,
      codiceMedico: firstItem?.medicoId,
      aziendaPrenotazione: firstItem?.struttura,
      agenda: firstItem?.agenda,
      tipologia: firstItem?.tipoAgenda,
      tipologiaDescrizione: firstItem?.tipologiaAgenda,
    };
  }, [calendarData]);
}

const NotePopUp = (props: {
  showPopupNote: boolean;
  setShowPopupNote: React.Dispatch<React.SetStateAction<boolean>>;
  handleEventClick: (info: any) => Promise<void>;
  setShowPrestazioniCombinateModal?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  dataSlot: any;
  popupNoteMessage: any;
}) => {
  return (
    <Box>
      <AllertMessage
        showAllert={props.showPopupNote}
        setShowAllert={props.setShowPopupNote}
        severity={"warning"}
        message={props?.popupNoteMessage}
        dataToSend={props?.dataSlot}
        submitFunction={props.handleEventClick}
        // submitFunction={() => {props.setShowPrestazioniCombinateModal(true);
        //   props.setShowPopupNote(false);
        // }}
      />
    </Box>
  );
};

const Calendar = ({
  generateID,
  calendarData,
  searchedDate,
  giorni = 15,
  onBookingComplete,
  setSearchSubmit,
  handleResetForm,
  handleScrollReset,
  setCancellationNotification,
  setCancellationModalTimer,
  handleCancellationNotification,
  loadingSpinner,
  setLoadingSpinner,
  primoAppuntamento,
  rowsEntiData,
  rowsPosizioneTicketData,
  rowsClassePrioritaData,
  message,
  setMessage,
  setAccordion,
  modalitaSospesi,
  setModalitaSospesi,
  listaOrariDettaglio,
  setListaOrariDettaglio,
}: {
  generateID: () => number;
  calendarData: CalendarEvent[];
  searchedDate: string;
  giorni?: number;
  loadingSpinner: boolean;
  setLoadingSpinner: (submitted: boolean) => void;
  onBookingComplete: () => void;
  handleResetForm: () => void;
  handleScrollReset: () => void;
  handleCancellationNotification: () => void;
  setSearchSubmit: (submitted: boolean) => void;
  setCancellationNotification: (notifica: boolean) => void;
  setCancellationModalTimer: (modalTimer: boolean) => void;
  primoAppuntamento: string;
  rowsEntiData: Enti[];
  rowsPosizioneTicketData: PosizioneTicket[];
  rowsClassePrioritaData: ClassePriorita[];
  message: string;
  setMessage: (message: string) => void;
  setAccordion: (show: boolean) => void;
  modalitaSospesi: ModalitaSospesi;
  setModalitaSospesi: React.Dispatch<React.SetStateAction<ModalitaSospesi>>;
  listaOrariDettaglio: FormatGrigliaOrariPerGestioneSospesi[];
  setListaOrariDettaglio: React.Dispatch<
    React.SetStateAction<FormatGrigliaOrariPerGestioneSospesi[]>
  >;
}) => {
  const context = useContext(DataContext);

  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(
    null
  );
  const [bookingResponse, setBookingResponse] = useState<any>(null);
  const [durata, setDurata] = useState<string>("");
  const [tempDurata, setTempDurata] = useState<string>("");
  const [idPaziente, setIdPaziente] = useState<string>("");
  const [data, setData] = useState<string>("");
  const [ora, setOra] = useState<string>("");
  const [tipoAgenda, setTipoAgenda] = useState<string>("");
  const [nomePaziente, setNome] = useState<string>("");
  const [cognomePaziente, setCognome] = useState<string>("");
  const [dataNascita, setDataNascita] = useState("");
  const [codiceFiscale, setCodiceFiscale] = useState<string>("");
  const [numeroTelefono, setNumeroTelefono] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [posizioneTicket, setPosizioneTicket] = useState("");
  const [classePriorita, setClassePriorita] = useState("");
  const [numeroImpegnativa, setNumeroImpegnativa] = useState("");
  const [dataImpegnativa, setDataImpegnativa] = useState<string>("");
  const [ente, setEnte] = useState("");
  const [numeroTessera, setNumeroTessera] = useState("");
  const [suggerita, setSuggerita] = useState(false);
  const [primoAccesso, setPrimoAccesso] = useState(false);
  const [tipoCalcolo, setTipoCalcolo] = useState("");
  const [note, setNote] = useState("");
  const [diagnosiNote, setDiagnosiNote] = useState("");
  const [prioritaNote, setPrioritaNote] = useState("");
  const [distrettoNote, setDistrettoNote] = useState("");

  const [
    posizioneTicketDataByPrenotazione,
    setPosizioneTicketDataByPrenotazione,
  ] = useState<CodicePostic[]>([]);

  const [openSummary, setOpenSummary] = useState(false);
  const [summaryData, setSummaryData] = useState<any>(null);
  const [appointmentDetails, setAppointmentDetails] = useState<any>();
  const [showAllert, setShowAllert] = useState(false);
  const [severity, setSeverity] = useState<
    "success" | "error" | "info" | "warning"
  >("error");

  // States per la gestione del popUp di intermezzo alla selezione dello slot
  const [showPopupNote, setShowPopupNote] = useState(false);
  const [dataSlot, setDataSlot] = useState<any>(null);
  const [popupNoteMessage, setPopupNoteMessage] = useState<any>();
  const [notesByDate, setNotesByDate] = useState<Record<string, DoctorNote[]>>(
    {}
  );

  // States pel la gestione della modale di prestazioni combinate (in caso di presenza come opzione)
  const [showPrestazioniCombinateModal, setShowPrestazioniCombinateModal] =
    useState(false);

  // State per mostrare la schermata dei dati regionali compilabili in caso di parametrica G++
  const [showRegionDataDetail, setShowRegionDataDetail] = useState(false);

  // States per la gestione della visualizzazioni delle opzioni scelte tramite il menu options
  const [showOptionNoteGiornaliere, setShowOptionNoteGiornaliere] =
    useState(false);
  const [showOptionOrarioGiornaliero, setShowOptionOrarioGiornaliero] =
    useState(false);
  const [
    showOptionCancellazioneOrarioGiornaliero,
    setShowOptionCancellazioneOrarioGiornaliero,
  ] = useState(false);
  const [
    showOptionInserireIndisponibilita,
    setShowOptionInserireIndisponibilita,
  ] = useState(false);
  const [dataGiornoSelezionato, setDataGiornoSelezionato] = useState<any>();
  const [oggettoNotaSelezionato, setOggettoNotaSelezionato] = useState<any>();

  const [fn, setFn] = useState<(() => void) | null>(null);

  //Stati per gestire le prestazioni raggruppabili e combinate
  const [groupableOpen, setGroupableOpen] = useState(false);
  const [groupableProcedures, setGroupableProcedures] = useState<
    GroupableProcedureRow[] | null
  >(null);
  const [combinedProcedures, setCombinedProcedures] = useState<
    CombinedProceduresRow[] | null
  >(null);

  const calendarInfo = useCalendarInfo(calendarData);

  useEffect(() => {
    if (showAllert && !fn) {
      const timer = setTimeout(() => {
        setShowAllert(false);
        setFn(null);
        if (severity === "success") onBookingComplete();
      }, 5000); // 5 secondi
      return () => clearTimeout(timer);
    }
  }, [showAllert, fn]);

  // Id per l'alternanza dell'immagine al momento della generazione del calendar
  const id = useMemo(() => generateID(), []);

  // UseState per gli steps della modale ReservationSteppers
  const [activeStep, setActiveStep] = useState(0);

  //Stato per salvare l'idPacada per le prenotazioni raggruppabili
  const [idPacadaProcedure, setIdPacadaProcedure] = useState<string>("");
  const [groupingHeader, setGroupingHeader] = useState<{
    tipo: string;
    descr: string;
  } | null>(null);

  const handleReset = () => {
    setActiveStep(0);
  };

  const containerRef = useRef<HTMLDivElement>(null);

  //Funzione per sincronizzare lo scorrimento orizzontale tra i calendari
  useEffect(() => {
    const syncScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      const scrollLeft = target.scrollLeft;

      // Rimuove temporaneamente i listener di scroll per evitare loop di sincronizzazione
      scrollerElements.forEach((el) =>
        el.removeEventListener("scroll", syncScroll)
      );

      // Sincronizza la posizione di scroll sugli altri elementi scrollabili
      scrollerElements.forEach((el) => {
        if (el !== target && el.scrollWidth > el.clientWidth) {
          el.scrollLeft = scrollLeft;
        }
      });

      // Riaggiunge i listener di scroll per evitare loop
      scrollerElements.forEach((el) =>
        el.addEventListener("scroll", syncScroll)
      );
    };

    // Prende tutti i container che contengono i calendari
    const calendarContainers = document.querySelectorAll<HTMLElement>(
      ".calendar-container"
    );
    let scrollerElements: HTMLElement[] = [];

    calendarContainers.forEach((container) => {
      // Seleziona gli elementi scrollabili all'interno di ciascun container
      const elements = Array.from(
        container.querySelectorAll<HTMLElement>(
          ".fc-scroller, .fc-scrollgrid-sync-table, .fc-scrollgrid, .fc-scroller-harness, .fc-scroller-harness-liquid"
        )
      );

      // Aggiunge ogni elemento trovato alla lista degli elementi scrollabili
      scrollerElements = scrollerElements.concat(elements);

      // Aggiunge i listener di scroll per ogni elemento trovato
      elements.forEach((el) => {
        el.addEventListener("scroll", syncScroll);
      });
    });

    // Rimuove gli event listener al dismount del componente
    return () => {
      scrollerElements.forEach((el) =>
        el.removeEventListener("scroll", syncScroll)
      );
    };
  }, []);

  // opzionale: evita chiamate duplicate per stesso range
  const lastRangeKeyRef = useRef<string>("");

  const fetchNotesForRange = async (
    dataIni: string,
    dataFin: string,
    opts?: { force?: boolean }
  ) => {
    const key = `${dataIni}|${dataFin}|${calendarInfo.medico.join(",")}`;
    if (!opts?.force && key === lastRangeKeyRef.current) return;
    lastRangeKeyRef.current = key;

    // Effettuo una chiamata per ogni medico
    const jobs = calendarInfo.medico.map((medico) =>
      panoteg({
        crud: "r",
        aziendaPrenotazione: calendarInfo.aziendaPrenotazione,
        idNota: "",
        medico: calendarInfo.codiceMedico,
        testoNota: "",
        data: "",
        dataIni,
        dataFin,
      })
        .then((res: any) => {
          const arr = res?.data?.dati?.nota ?? [];
          // normalizza e filtra solo le note con le stringhe non vuote
          const normalized: DoctorNote[] = arr
            .filter((n: any) => (n?.DESCRNOTA ?? "").trim().length > 0)
            .map((n: any) => ({
              id: String(n.IDNOTA),
              medico: String(n.CODMEDICO),
              nominativo: n.NOMINMEDICO ? String(n.NOMINMEDICO) : undefined,
              data: String(n.DATANOTA),
              testo: String(n.DESCRNOTA),
            }));
          // console.log(
          //   "[PANOTEG] medico:",
          //   medico,
          //   "range:",
          //   dataIni,
          //   dataFin,
          //   "notes:",
          //   normalized
          // );
          return normalized;
        })
        .catch((err: any) => {
          console.warn("[PANOTEG] errore medico:", medico, err);
          return [] as DoctorNote[];
        })
    );

    const perMedico = await Promise.all(jobs);
    const flat: DoctorNote[] = perMedico.flat();
    // console.log("[PANOTEG] flat notes:", flat);

    // Raggruppo per la data
    const byDate: Record<string, DoctorNote[]> = {};
    flat.forEach((n) => {
      (byDate[n.data] ||= []).push(n);
    });
    // console.log("[PANOTEG] byDate:", byDate);

    // Unisco le note già presenti con quelle nuove (merge)
    setNotesByDate((prev) => {
      const next: Record<string, DoctorNote[]> = { ...prev };
      Object.entries(byDate).forEach(([day, list]) => {
        const existing = next[day] ?? [];
        // Rimuovo i duplicati con il map
        const byId = new Map<string, DoctorNote>();
        [...existing, ...list].forEach((item) => byId.set(item.id, item));
        next[day] = Array.from(byId.values());
      });
      return next;
    });
  };

  // ricava le date dalla view attuale di FullCalendar e richiamo fetchNotesForRange
  const refreshVisibleRangeNotes = (opts?: { force?: boolean }) => {
    const api = calendarRef.current?.getApi();
    if (!api) return;

    const start =
      (api.view as any)?.activeStart ||
      (api.view as any)?.currentStart ||
      api.getDate();
    const end =
      (api.view as any)?.activeEnd ||
      (api.view as any)?.currentEnd ||
      api.getDate();

    const dataIni = dayjs(start).format("YYYY-MM-DD");
    const dataFin = dayjs(end).subtract(1, "day").format("YYYY-MM-DD");
    lastRangeKeyRef.current = "";
    fetchNotesForRange(dataIni, dataFin, { force: opts?.force });
  };

  const dayHeaderContent = (info: any) => {
    const date = info.date;
    const ymd = dayjs(date).format("YYYY-MM-DD");
    const notes = notesByDate[ymd];

    const day = date.toLocaleDateString("it-IT", { weekday: "short" });
    const dayCapitalized = day.charAt(0).toUpperCase() + day.slice(1);
    const fullDate = date.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const dayStyle: React.CSSProperties = {
      fontWeight: "bold",
      color: date.getDay() === 0 ? "#E20000" : "inherit",
      paddingLeft: 4,
    };

    const oggettoNota = notes?.[0] ?? null;

    const notaRelativa = notes
      ?.map((n) => `Nota giornaliera: ${n.testo}`)
      .join("\n");

    return (
      <>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
        >
          {/* prima riga: icona, giorno, puntini */}
          <Box display="flex" alignItems="center" gap={0.5}>
            {notes?.length ? (
              <Tooltip
                title={
                  <div style={{ whiteSpace: "pre-line" }}>{notaRelativa}</div>
                }
                arrow
                placement="top"
              >
                <WarningAmberIcon
                  sx={{
                    fontSize: 18,
                    color: "#E65100",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            ) : (
              <WarningAmberIcon sx={{ fontSize: 18, visibility: "hidden" }} />
            )}

            <span style={dayStyle}>{dayCapitalized}</span>

            <OptionsMenu
              {...propsOpzioniGiornaliere}
              data={dayjs(ymd).format("YYYY-MM-DD")}
              oggettoNota={oggettoNota}
              setShowOrarioDettaglio={context?.setShowOrarioGiornaliero}
            />
          </Box>

          {/* seconda riga: data */}
          <div style={{ color: "#A0A5A9", fontWeight: "normal" }}>
            {fullDate}
          </div>
        </Box>
      </>
    );
  };

  const formatDate = (dateString: string) => {
    return dayjs(dateString, "YYYYMMDD").format("YYYY-MM-DD");
  };

  const initialDate = formatDate(primoAppuntamento);

  const handleTimeOut = () => {
    // handleClose();
    handleAppointmentAbort(
      "Il tempo è scaduto, l'inserimento è stato annullato"
    );
    setSelectedEvent(null);
  };

  // const handleCancellation = () => {
  //   // handleClose();
  //   // handleAppointmentAbort("L'inserimento è stato annullato");
  //   setSelectedEvent(null);
  //   context?.setNumeroAppuntamentoRiepilogo("");
  // };

  const handleClose = () => {
    handleReset();
    setSelectedEvent(null);
    context?.setNumeroAppuntamentoRiepilogo("");
    setOpen(false);
  };

  // const handleNotePopup = (info: any) => {
  //   setShowPopupNote(true);
  //   setDataSlot(info);
  //   const dayKey = getWeekdayFromEvent(info);

  //   setPopupNoteMessage(
  //     dayKey && info.event.extendedProps.noteSettimana[dayKey]
  //       ? info.event.extendedProps.noteSettimana[dayKey]
  //       : info.event.extendedProps.notaMedico === ""
  //       ? ""
  //       : info.event.extendedProps.notaMedico
  //   );
  // };

  const handleNotePopup = (info: any) => {
    const dayKey = getWeekdayFromEvent(info);

    const weeklyNote =
      dayKey && info.event.extendedProps.noteSettimana
        ? info.event.extendedProps.noteSettimana[dayKey]
        : "";

    const doctorNote = info.event.extendedProps.notaMedico || "";

    // Messaggio finale da mostrare nell'alert
    const message = weeklyNote || doctorNote;

    // Se NON ci sono note vado direttamente allo stepper
    if (!message || message.trim() === "") {
      handleEventClick(info);
      return;
    }

    // Se ci sono note mostra l'alert
    setPopupNoteMessage(message);
    setDataSlot(info);
    setShowPopupNote(true);
  };

  const handleEventClick = async (clickInfo: any) => {
    console.log({ clickInfo });

    setShowPopupNote(false);
    context?.setNumeroAppuntamentoRiepilogo("");
    const formatOra = (ora: string) => {
      return ora.length === 4 ? `${ora.slice(0, 2)}:${ora.slice(2)}` : ora;
    };

    const eventDetails = {
      title: clickInfo.event.title,
      start: clickInfo.event.start,
      medicoId: clickInfo.event.extendedProps.medicoId,
      nominativoMedico: clickInfo.event.extendedProps.nominativoMedico,
      struttura: clickInfo.event.extendedProps.struttura,
      sede: clickInfo.event.extendedProps.sede,
      sedeIndirizzo: clickInfo.event.extendedProps.sedeIndirizzo,
      tariffa: clickInfo.event.extendedProps.tariffa,
      durata: clickInfo.event.extendedProps.durataPrestazione ?? "10",
      genere: clickInfo.event.extendedProps.genere,
      specialita: clickInfo.event.extendedProps.specialita,
      prestazione: clickInfo.event.extendedProps.prestazione,
      data: new Date(
        clickInfo.event.extendedProps.data || clickInfo.event.startStr
      )
        .toISOString()
        .split("T")[0],
      ora: formatOra(
        clickInfo.event.extendedProps.ora ||
          clickInfo.event.startStr.split("T")[1]
      ),
      tipoAgenda: clickInfo.event.extendedProps.tipoAgenda,
      medico: clickInfo.event.extendedProps.medicoId,
      importo: clickInfo.event.extendedProps.tariffa || "50",
      primaDisponibilita:
        formatDate(clickInfo.event.extendedProps.primaDisponibilita) || "",
      agenda: clickInfo.event.extendedProps.agenda,
      descrizioneTipoAgenda: clickInfo.event.extendedProps.tipologiaAgenda,
      descrizioneSpecialita:
        clickInfo.event.extendedProps.descrizioneSpecialita,
      descrizionePrestazione:
        clickInfo.event.extendedProps.descrizionePrestazione,
      idPacate: Number(context?.idsGenerati?.IdPacata),
      idPacapr: Number(context?.idsGenerati?.IdPacapr),
      idPacada: Number(context?.idsGenerati?.IdPacada),
    };

    // NOTA: Inserito per popolare pre rendering il field della modale, da trovare solution
    setTempDurata(eventDetails.durata);
    setSelectedEvent(eventDetails);

    context?.setMedico(eventDetails.nominativoMedico);

    const {
      specialita,
      prestazione,
      data,
      ora,
      tipoAgenda,
      medico,
      durata,
      importo,
      primaDisponibilita,
      agenda,
      idPacate,
      idPacapr,
      idPacada,
    } = eventDetails;

    console.log({ eventDetails });

    let esitoNegativo = false;

    // PRIMA: try di chiamata per prenotare lo slot
    try {
      setLoadingSpinner(true);
      await bookSlot({
        specialita,
        prestazione,
        data,
        ora,
        tipoAgenda,
        medico,
        durata,
        importo,
        primaDisponibilita,
        agenda,
        idPacate,
        idPacapr,
        idPacada,
      }).then((response) => {
        console.log("Risposta bookSlot:", response.data);

        const esito = response.data.dati?.find(
          (item: any) => item.campo === "Esito"
        );

        // [REG] Estraggo idPacada e azienda e li salvo in Context per i Dati Regionali
        setIdPacadaProcedure(
          response.data.dati.find((item: any) => item.id === "17")?.dato
        );

        context?.setIdPacada(
          response.data.dati.find((item: any) => item.id === "17")?.dato
        );

        context?.setIdPacate(
          response.data.dati.find((item: any) => item.id === "15")?.dato
        );

        context?.setAziendaPrenotazione(eventDetails.struttura);

        if (esito?.variabile === "wk-esito" && esito?.dato === "KO") {
          console.error(
            "Errore: Esito KO da bookSlot, interruzione del flusso."
          );
          setMessage("Prenotazione non riuscita: esito KO.");
          setSeverity("error");
          setShowAllert(true);
          setOpen(false);
          esitoNegativo = true;
          return;
        }

        const tempPostic: CodicePostic[] = response.data.posizioniTicket
          ? response.data.posizioniTicket
          : [];

        setPosizioneTicketDataByPrenotazione(tempPostic);
        setBookingResponse(response.data.dati);
      });

      if (esitoNegativo) return;

      try {
        const payloadParaggr = {
          aziendaPrenotazione: clickInfo.event.extendedProps.struttura,
          codMedint: clickInfo.event.extendedProps.medicoId,
          codPgmedt: clickInfo.event.extendedProps.medicoId,
          codTpgpre: clickInfo.event.extendedProps.tipoAgenda,
          codSpecia: clickInfo.event.extendedProps.specialita,
          codAnapre: clickInfo.event.extendedProps.prestazione,
          dataApp: dayjs(
            clickInfo.event.extendedProps.data || clickInfo.event.startStr
          ).format("YYYY-MM-DD"),
        };

        // SECONDO: try di chiamata per verificare evenutale presenza di opzione per la selezione di prestazioni raggruppabili
        const responseParaggr = await paraggr(payloadParaggr);
        console.log({ payloadParaggr });
        const dati = responseParaggr?.data?.dati ?? [];

        const tipoRaggr = dati[0]?.dato ?? "";
        const descrTipoRaggr = dati[1]?.dato ?? "";

        if (dati[0]?.dato === "" && dati[1]?.dato === "") {
          try {
            // TERZO: try di chiamata per verificare evenutale presenza di opzione per la selezione di prestazioni combinate
            const responsePacomb = await pacomb(payloadParaggr);

            const datiPacomb = responsePacomb?.data?.dati ?? [];
            console.log({ datiPacomb });

            // se PACOMB è valorizzato, gestisco il modale ecc.
            if (!Array.isArray(datiPacomb[0]?.dati[1])) {
              //Mappo i dati delle due tabelle
              const daGdBlocks = datiPacomb.filter(
                (x: any) =>
                  typeof x?.campo === "string" && x.campo.includes("DaGd")
              );
              // Mappo i dati dei "titoli" a false
              const datiFiltrati = daGdBlocks
                .map((blocco: any) =>
                  blocco.dati.filter((riga: any) => riga?.titolo === "false")
                )
                .filter(Boolean);
              const campoIdMedPgm = datiPacomb.find(
                (x: any) =>
                  typeof x?.campo === "string" && x.campo.includes("idMedpgm")
              );

              const mappato: {
                id: string;
                idMedPgm: string;
                codice: string;
                descrizione: string;
                durataTot: string;
                specialita?: string;
                prestazione?: string;
                codSiss?: string;
              }[] = datiFiltrati
                .flatMap((gruppo: any[]) => gruppo)
                .map((riga: any) => {
                  const getDato = (campo: string) =>
                    riga.dati?.find((d: any) =>
                      d?.campo?.toLowerCase().includes(campo.toLowerCase())
                    )?.dato ?? "";

                  return {
                    id: getDato("id profilo"),
                    idMedPgm: campoIdMedPgm.dato ?? "",
                    codice: getDato("combinata"),
                    descrizione: getDato("descrizione"),
                    durataTot: getDato("durata"),
                    specialita: getDato("specialita"),
                    prestazione: getDato("prestazione"),
                    codSiss: getDato("cod siss"),
                  };
                });

              console.log("Calendar info before raggruppato", calendarInfo);

              const raggruppato = Object.values(
                mappato.reduce((acc, curr) => {
                  if (!acc[curr.id]) {
                    acc[curr.id] = {
                      id: curr.id,
                      idMedPgm: curr.idMedPgm,
                      aziendaPrenotazione:
                        calendarInfo.aziendaPrenotazione ?? "",
                      codice: curr.codice,
                      descrizione: curr.descrizione,
                      durataTot: Number(curr.durataTot) || 0,
                      composizioni: [],
                    };
                  }

                  if (curr.specialita || curr.prestazione || curr.codSiss) {
                    acc[curr.id].composizioni.push({
                      specialita: curr.specialita,
                      prestazione: curr.prestazione,
                      codSiss: curr.codSiss,
                      descrizioneSiss: curr.descrizione,
                      durata: Number(curr.durataTot) || 0,
                    });
                  }

                  return acc;
                }, {} as Record<string, CombinedProceduresRow>)
              ) as CombinedProceduresRow[];

              console.log({ raggruppato });

              setCombinedProcedures(raggruppato);
              setShowPrestazioniCombinateModal(true);
            } else {
              // Diretta apertura in caso di assenza di opzioni
              setOpen(true);
            }
          } catch (error) {
            console.error("Errore sulla fetch pacomb", error);
          }
        } else if (dati[0]?.dato?.length > 0 && dati[1]?.dato?.length > 0) {
          const daGdBlock = dati.find(
            (x: any) => typeof x?.campo === "string" && x.campo.includes("DaGd")
          );
          const daGdRowsRaw = Array.isArray(daGdBlock?.dati)
            ? daGdBlock.dati
            : [];
          setGroupableProcedures(daGdRowsRaw);
          setGroupableOpen(true);

          setGroupingHeader({ tipo: tipoRaggr, descr: descrTipoRaggr });
        }
      } catch (error) {
        console.error("Errore sulla fetch paraggr", error);
      }
    } catch (error) {
      console.error("Errore sulla fetch bookslot", error);
    } finally {
      setLoadingSpinner(false);
    }
  };

  const renderEventContent = (eventInfo: any) => {
    // console.log({eventInfo});
    return (
      <div className="eventInfo">
        <p className="test">{eventInfo.timeText}</p>
      </div>
    );
  };

  const doctorsMap: { [medicoId: string]: CalendarEvent[] } = {};
  calendarData.forEach((event) => {
    if (!doctorsMap[event.medicoId]) {
      doctorsMap[event.medicoId] = [];
    }
    doctorsMap[event.medicoId].push(event);
  });

  // useEffect(() => {
  //   console.log("Calendar Data", calendarData);
  // }, [calendarData]);

  // Funzione per il recupero della giornata in base all'ISO dell data in arrivo dall'evento di fullCalendar
  // necessario per la corretta assegnazione e check delle note in arrivo dalla api ricDisp in base al giorno della settimana
  function getWeekdayFromEvent(eventData: any) {
    // Prendiamo la data dal campo "selectedDate" o "start"
    const dateStr =
      eventData.event?.start || eventData.event?.extendedProps?.selectedDate;
    if (!dateStr) return null;

    // console.log({ dateStr });

    // Creiamo un oggetto Date
    const date = new Date(dateStr);

    // Giorni della settimana in italiano
    const giorni = [
      "notaDom",
      "notaLun",
      "notaMar",
      "notaMer",
      "notaGio",
      "notaVen",
      "notaSab",
    ];

    // Ritorniamo il nome del giorno
    return giorni[date.getDay()];
  }

  // [REG] Gestisce la chiusura della maschera "Dati Regionali" avanzando nella coda
  const handleRegionDataClose = () => {
    // [REG] Chiedo al Context di togliere l’ID appena processato e dirmi il prossimo
    const res = context?.advanceRegionDataQueue();
    const next = res?.next;
    const remaining = res?.remainingCount ?? 0;

    // console.log("[handleRegionDataClose] next:", next, "remaining:", remaining);

    if (next) {
      // [REG] Se ho un altro ID in coda, lo imposto e riapro il modale
      context?.setIdPacada(next);
      setShowRegionDataDetail(false);
      setTimeout(() => setShowRegionDataDetail(true), 0);
    } else {
      // [REG] Se la coda è finita, chiudo i “Dati Regionali” e apro il riepilogp
      setShowRegionDataDetail(false);
      setOpenSummary(true);
    }
  };

  //Funzioni per organizzare le prestazioni raggruppate e combinate selezionate
  const parseParaggr = (resp: any) => {
    const blocks = resp?.data?.dati ?? [];
    const grid = blocks.find(
      (b: any) => typeof b?.campo === "string" && b?.tipo === "GRID"
    );
    const rows = Array.isArray(grid?.dati) ? grid.dati : [];

    type Row = { tipo?: string; titolo?: string; pkey?: string; dati?: any[] };
    const appointments: {
      id: string;
      specialita?: string;
      prestazione?: string;
      codSiss?: string;
    }[] = [];

    rows.forEach((r: Row) => {
      if (
        r?.tipo === "RIGAGRID" &&
        r?.titolo === "false" &&
        typeof r?.pkey === "string"
      ) {
        const map: Record<string, string> = {};
        (r.dati ?? []).forEach((cell: any) => {
          if (cell?.campo) map[cell.campo.toLowerCase()] = cell?.dato ?? "";
        });
        appointments.push({
          id: r.pkey.trim(),
          specialita: map["specialita"] ?? "",
          prestazione: map["prestazione"] ?? "",
          codSiss: map["cod siss"] ?? "",
        });
      }
    });

    return appointments;
  };

  const parsePacomb = (resp: any) => {
    const blocks = resp?.data?.dati ?? [];

    // cerca il primo blocco GRID che contiene "DaGd"
    const grid = blocks.find(
      (b: any) =>
        typeof b?.campo === "string" &&
        b?.tipo === "GRID" &&
        b.campo.toLowerCase().includes("dagd")
    );
    const rows = Array.isArray(grid?.dati) ? grid.dati : [];

    type Row = { tipo?: string; titolo?: string; pkey?: string; dati?: any[] };
    const out: {
      id: string;
      specialita?: string;
      prestazione?: string;
      codSiss?: string;
    }[] = [];

    rows.forEach((r: Row) => {
      if (
        r?.tipo === "RIGAGRID" &&
        r?.titolo === "false" &&
        typeof r?.pkey === "string"
      ) {
        const map: Record<string, string> = {};
        (r.dati ?? []).forEach((cell: any) => {
          if (cell?.campo)
            map[cell.campo.trim().toLowerCase()] = (cell?.dato ?? "").trim();
        });
        out.push({
          id: r.pkey.trim(),
          specialita: map["specialita"] ?? "",
          prestazione: map["prestazione"] ?? "",
          codSiss: map["cod siss"] ?? "",
        });
      }
    });

    return out;
  };

  const postAppointmentData = async (appointmentData: any) => {
    try {
      // 1. Conferma prenotazione con gestisciAppuntamento
      const response = await manageAppointment(appointmentData);

      const esito = response?.data?.dati?.find(
        (item: any) => item.campo === "Esito"
      );

      if (esito?.variabile === "wk-esito" && esito?.dato === "KO") {
        setMessage("Prenotazione fallita: esito KO.");
        setSeverity("error");
        setShowAllert(true);
        setShowRegionDataDetail(false);
        return false;
      }

      // [REG] 2u Se ho payload RAGGRUPPABILI → chiamo wParaggr, parso righe e preparo hints + coda
      if (context?.groupableProceduresPayload) {
        try {
          const respParaggr = await wParaggr(
            context.groupableProceduresPayload
          );
          const parsed = parseParaggr(respParaggr);

          if (parsed.length > 0) {
            // [REG] Id prenotato principale (bookedId) + tutti gli ID generati per le righe raggruppabili
            const bookedId =
              bookingResponse?.find((it: any) => it.id === "17")?.dato ||
              context.idPacada;

            const ids = [
              bookedId,
              ...parsed.map((p) => p.id).filter((id) => id && id !== bookedId),
            ];

            // [REG] Preparo gli hints per pre-popolare il form del modale “Dati Regionali”
            const baseHint = {
              specialita: selectedEvent?.specialita,
              prestazione: selectedEvent?.prestazione,
              codSiss: undefined,
            };

            const hints = parsed.reduce((acc, cur) => {
              acc[cur.id] = {
                specialita: cur.specialita,
                prestazione: cur.prestazione,
                codSiss: cur.codSiss,
              };
              return acc;
            }, {} as Record<string, { specialita?: string; prestazione?: string; codSiss?: string }>);

            // [REG] Salvo hints in Context (incluso l’ID principale)
            context.setRegionDataHints({
              ...context.regionDataHints,
              ...(bookedId ? { [bookedId]: baseHint } : {}),
              ...hints,
            });

            // [REG] Enqueue di tutti gli ID da processare nel modale (senza duplicati) e setto il primo come corrente
            const unique = Array.from(new Set(ids.filter(Boolean)));
            if (unique.length) {
              context.enqueueRegionData(unique);
              context.setIdPacada(unique[0]);
            }
          } else {
            // [REG] Se non ho righe, azzero hints
            context.setRegionDataHints({});
          }
        } catch (err) {
          console.error("Errore wParaggr:", err);
          setMessage(
            "Errore nella generazione delle prestazioni raggruppabili."
          );
          setSeverity("error");
          setShowAllert(true);
          return false;
        } finally {
          context.setGroupableProceduresPayload(null);
        }
      }

      // [REG] 3) Se ho payload COMBINATE chiamo wPacomb, parso righe e preparo hints + coda
      if (context?.combinedProcedurePayload) {
        try {
          const respwPacomb = await wPacomb(context.combinedProcedurePayload);
          const parsed = parsePacomb(respwPacomb);

          if (parsed.length > 0) {
            const bookedId =
              bookingResponse?.find((it: any) => it.id === "17")?.dato ||
              context.idPacada;

            const ids = [
              bookedId,
              ...parsed.map((p) => p.id).filter((id) => id && id !== bookedId),
            ];

            const baseHint = {
              specialita: selectedEvent?.specialita,
              prestazione: selectedEvent?.prestazione,
              codSiss: undefined,
            };

            const hints = parsed.reduce((acc, cur) => {
              acc[cur.id] = {
                specialita: cur.specialita,
                prestazione: cur.prestazione,
                codSiss: cur.codSiss,
              };
              return acc;
            }, {} as Record<string, { specialita?: string; prestazione?: string; codSiss?: string }>);

            // [REG] Salvo hints per tutte le righe (ID principale + composte)
            context.setRegionDataHints({
              ...context.regionDataHints,
              ...(bookedId ? { [bookedId]: baseHint } : {}),
              ...hints,
            });

            // [REG] Metto gli ID in coda e imposto il primo da aprire
            const unique = Array.from(new Set(ids.filter(Boolean)));
            if (unique.length) {
              context.enqueueRegionData(unique);
              context.setIdPacada(unique[0]);
            }
          } else {
            context.setRegionDataHints({});
          }

          console.log("Response wPacomb:", respwPacomb.data);
        } catch (err) {
          console.error("Errore wPacomb:", err);
          setMessage("Errore nella generazione delle prestazioni combinate.");
          setSeverity("error");
          setShowAllert(true);
          return false;
        } finally {
          context.setCombinedProcedurePayload(undefined);
        }
      }

      // [REG] 4) Caso prenotazione SINGOLa → preparo hint per il solo ID prenotato e lo metto in coda

      if (
        !context?.groupableProceduresPayload &&
        !context?.combinedProcedurePayload
      ) {
        const bookedId =
          bookingResponse?.find((it: any) => it.id === "17")?.dato ||
          context?.idPacada;

        if (bookedId) {
          // [REG] Hint base per pre-popolare il form
          context?.setRegionDataHints({
            ...context.regionDataHints,
            [bookedId]: {
              specialita: selectedEvent?.descrizioneSpecialita,
              prestazione: selectedEvent?.descrizionePrestazione,
              codSiss: "",
            },
          });
          // [REG] Metto in coda l’unico ID e lo imposto come corrente
          context?.enqueueRegionData([bookedId]);
          context?.setIdPacada(bookedId);
        } else {
          context?.setRegionDataHints({});
        }
      }
      // [REG] Prenotazione confermata → chiudo la modale principale
      setOpen(false);
      return true;
    } catch (error) {
      console.error("Errore durante manageAppointment:", error);
      setMessage("Errore durante la gestione dell'appuntamento.");
      setSeverity("error");
      setShowAllert(true);
      return false;
    }
  };

  const handleAppointmentAbort = async (message: string) => {
    setLoadingSpinner(true);
    setMessage(message);
    context?.setTimeExpiry(null)

    if (!selectedEvent || !bookingResponse) return;

    const idPacate = bookingResponse.find(
      (item: any) => item.id === "15"
    )?.dato;
    const idPacapr = bookingResponse.find(
      (item: any) => item.id === "16"
    )?.dato;
    const idPacada = bookingResponse.find(
      (item: any) => item.id === "17"
    )?.dato;

    if (!idPacate || !idPacapr || !idPacada) {
      console.error(
        "Errore durante l'estrazione dei dati dall'API di bookSlot"
      );
      return;
    }

    // Dati registrati durante la compilazione dell'appuntamento
    const appointmentData = {
      // questi campi devono restare assegnati altrimenti sparisce finestra prenotabile
      keyStatus: "27",
      idPaziente: "",
      medico: selectedEvent.medicoId,
      data: selectedEvent.data,
      ora: selectedEvent.ora,
      durata: selectedEvent.durataPrestazione ?? "",
      prestazione: selectedEvent.prestazione,
      specialita: selectedEvent.specialita,
      tipoAgenda: selectedEvent.tipoAgenda,
      agenda: selectedEvent.agenda,
      importo: selectedEvent.importo,
      codiceOperatore: selectedEvent.codiceOperatore,
      idPacate,
      idPacapr,
      idPacada,
      // campi che devono essere svuotati
      cognomePaziente: "",
      nomePaziente: "",
      primaDisponibilita: selectedEvent.primaDisponibilita,
      telefonoPaziente: "",
      codicePosTic: "",
      flSuggerita: "",
      codiceIUP: "",
      idEnte: "",
      numeroImpegnativa: "",
      dataImpegnativa: "",
      codiceClsPrio: "",
    };

    await manageAppointment(appointmentData)
      .then(() => {
        setCancellationModalTimer(true);
        setCancellationNotification(true);
        handleCancellationNotification();
        onBookingComplete();
      })
      .catch((error) => {
        console.error("Errore durante annullamento appuntamento:", error);
      })
      .finally(() => {
        setOpen(false);
        setLoadingSpinner(false);
      });
  };

  const addAppointmentToList = (appointmentData: any) => {
    context?.addAppointmentToList({
      descrizionePrestazione: appointmentData.descrizionePrestazione,
      nominativoMedico: appointmentData.nominativoMedico,
      data: appointmentData.data,
      ora: appointmentData.ora,
      durata: appointmentData.durata,
      importo: appointmentData.importo || "50.00",
      tipoAgenda: appointmentData.tipoAgenda,
      descrizioneTipoAgenda: appointmentData.descrizioneTipoAgenda,
      nomePaziente: appointmentData.nomePaziente,
      cognomePaziente: appointmentData.cognomePaziente,
      codiceOperatore: appointmentData.codiceOperatore,
      descrizioneSpecialita: appointmentData.descrizioneSpecialita,
      medico: appointmentData.medico,
      codice: appointmentData.codice,
    });
  };

  const handleAppointmentSubmit = async (value: number) => {
    console.log("[handleAppointmentSubmit] chiamato con value:", value);
    context?.setTimeExpiry(null);

    if (!selectedEvent || !bookingResponse) return;

    const formatYYYYMMDD = (v?: string) =>
      v ? dayjs(v).format("YYYY-MM-DD") : "";

    /**
     * Se gli id richiesti per la gestione dell'inserimento multiplo non risultano assegnati
     * all'interno dei loro campi context vengono recuperati ex-novo dalla prenotazione effettuata,
     * altrimenti vengono assegnati
     */
    const idPacate = !context?.idsGenerati?.IdPacata
      ? bookingResponse.find((item: any) => item.id === "15")?.dato
      : context?.idsGenerati.IdPacata;
    const idPacapr = !context?.idsGenerati?.IdPacapr
      ? bookingResponse.find((item: any) => item.id === "16")?.dato
      : context?.idsGenerati.IdPacapr;
    const idPacada = !context?.idsGenerati?.IdPacada
      ? bookingResponse.find((item: any) => item.id === "17")?.dato
      : context?.idsGenerati.IdPacada;

    const idPacadaOld = context?.idsGenerati?.idPacadaOld;

    console.log("HANDLE APPOINTMENT SUBMIT", {
      idPacate,
      idPacapr,
      idPacada,
      idPacadaOld,
    });

    if (!idPacate || !idPacapr || !idPacada) {
      console.error(
        "Errore durante l'estrazione dei dati degli id per la gestione appuntamenti dalle API di bookSlot"
      );
      return;
    }

    if (!context?.pazienteData) {
      const tempPatient: Patient = {
        CODICEFISCALE: codiceFiscale,
        COGNOME: cognomePaziente,
        DATANASCPAZIENTE: dataNascita,
        EMAIL: email,
        IDPAZIENTE: idPaziente,
        NOME: nomePaziente,
        TELEFONO: numeroTelefono,
      };

      context?.setPazienteData(tempPatient);
    }

    // Dati registrati durante la compilazione dell'appuntamento
    const appointmentData = {
      keyStatus: "12",
      idPaziente: !idPaziente
        ? context?.pazienteData?.IDPAZIENTE
          ? context?.pazienteData?.IDPAZIENTE
          : ""
        : idPaziente,
      nominativoMedico: selectedEvent.nominativoMedico,
      medico: selectedEvent.medicoId,
      data: data !== "" ? data : selectedEvent.data,
      ora: ora !== "" ? ora : selectedEvent.ora,
      durata: selectedEvent.durata,
      prestazione: selectedEvent.prestazione,
      specialita: selectedEvent.specialita,
      tipoAgenda: tipoAgenda !== "" ? tipoAgenda : selectedEvent.tipoAgenda,
      agenda: selectedEvent.agenda,
      importo: selectedEvent.importo,
      codiceOperatore: selectedEvent.codiceOperatore || "",
      idPacate,
      idPacapr,
      idPacada,
      idPacadaOld,
      cognomePaziente: !cognomePaziente
        ? context?.pazienteData?.COGNOME
        : cognomePaziente,
      codiceFiscale: !codiceFiscale
        ? context?.pazienteData?.CODICEFISCALE
        : codiceFiscale,
      nomePaziente: !nomePaziente ? context?.pazienteData?.NOME : nomePaziente,
      primaDisponibilita: selectedEvent.primaDisponibilita,
      email: email !== "" ? email : "",
      telefonoPaziente: !numeroTelefono
        ? context?.pazienteData?.TELEFONO
        : numeroTelefono,
      codicePostic: posizioneTicket,
      flSuggerita: suggerita ? "1" : "0",
      flPrimoAccesso: primoAccesso ? "1" : "0",
      idEnte: ente,
      numeroImpegnativa: numeroImpegnativa,
      numeroTessera: numeroTessera,
      dataImpegnativa: dataImpegnativa,
      codiceClsprt: classePriorita,
      notePrenot: note,
      noteAppuntamento: prioritaNote,
      diagnosiAppuntamento: diagnosiNote,
      distretto: distrettoNote,
      descrizioneTipoAgenda: selectedEvent.descrizioneTipoAgenda,
      descrizionePrestazione: selectedEvent.descrizionePrestazione,
      descrizioneSpecialita: selectedEvent.descrizioneSpecialita,
      dataNascitaPaziente: dataNascita
        ? formatYYYYMMDD(dataNascita)
        : formatYYYYMMDD(context?.pazienteData?.DATANASCPAZIENTE),
      aziendaPrenotazione: selectedEvent.struttura,
    };

    // oggetto dei campi da controllare se compilati durante il processo
    const fieldsToCheck = {
      nomePaziente: appointmentData.nomePaziente,
      cognomePaziente: appointmentData.cognomePaziente,
    };

    // Controllo dei campi null o undefined
    const emptyFields = Object.entries(fieldsToCheck)
      .filter(
        ([key, value]) => value === null || value === undefined || value === ""
      )
      .map(([key]) => key);

    const formatStringFieldName: string[] = emptyFields.map(
      (value: string, index: number) => {
        const tempFormatted = value.replace(`Paziente`, `, `);
        if (emptyFields.length === index + 1) {
          return tempFormatted.replace(`,`, `.`);
        }
        return tempFormatted;
      }
    );

    if (emptyFields.length > 0) {
      console.log(
        "I seguenti campi sono null, undefined o vuoti:",
        emptyFields
      );
      setMessage(
        `Qualcosa è andato storto nella copilazione del form su questi campi: ${formatStringFieldName[0]} ${formatStringFieldName[1]}`
      );
      setCancellationNotification(true);
      setCancellationModalTimer(true);
      handleCancellationNotification();
      setActiveStep(1);

      return;
    } else {
      console.log("Tutti i campi sono valorizzati correttamente.");
    }

    // Use state per i dettagli dell'appuntamento nel riepilogo di un appuntamento
    setAppointmentDetails(appointmentData);

    // switch case che a seconda dello status del tipo di prenotazione selezionata dall'utente e assegnato nel context gestirà le logiche previste
    switch (value) {
      case 0:
        await postAppointmentData(appointmentData);
        context?.setIdsGenerati({
          IdPacata: "",
          IdPacapr: "",
          IdPacada: "",
        });
        context?.setNumeroAppuntamento("");
        context?.setPazienteData(undefined);
        context?.setStatusAvanzamentoPrenotazione(0);
        context?.setTipoAgendaLock("");
        addAppointmentToList(appointmentData);
        context?.setEnte(ente);
        setShowRegionDataDetail(true);
        break;

      case 1:
        await postAppointmentData(appointmentData);
        context?.setStatusAvanzamentoPrenotazione(1);
        console.log("Tipo agenda", selectedEvent.tipoAgenda);
        context?.setTipoAgendaLock(selectedEvent.tipoAgenda ?? "ALL");
        context?.setIdsGenerati({
          IdPacata: idPacate,
          IdPacapr: idPacapr,
          IdPacada: "",
        });
        addAppointmentToList(appointmentData);
        break;

      case 2:
        await postAppointmentData(appointmentData);
        context?.setStatusAvanzamentoPrenotazione(2);
        context?.setTipoAgendaLock("");
        context?.setIdsGenerati({
          IdPacata: idPacate,
          IdPacapr: "",
          IdPacada: "",
        });
        addAppointmentToList(appointmentData);
        break;

      case 3:
        await postAppointmentData(appointmentData);
        console.log("Appuntamento modificato", appointmentData);
        break;

      default:
        console.error("Errore durante la submit dei Dati dell'appuntamento");
        break;
    }
  };

  // Intercetta la chiusura della finestra o della scheda
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (open) {
        handleClose();
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Pulizia dell'evento al termine
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [open, selectedEvent, bookingResponse]);

  // Utilizza `useMemo` per calcolare solo una volta gli eventi
  const memoizedEvents = useMemo(() => {
    return calendarData.map((event) => ({
      ...event,
      extendedProps: {
        medicoId: event.medicoId,
        nominativoMedico: event.nominativoMedico,
        struttura: event.struttura,
        sede: event.sede,
        sedeIndirizzo: event.sedeIndirizzo,
        tariffa: event.tariffa,
        durata: event.durataPrestazione,
        genere: event.genere,
        importo: event.importo,
        noteSettimana: event.noteSettimana,
        notaMedico: event.notaMedico,
        flagOrarioGiornaliero: event.flagOrarioGiornaliero,
      },
    }));
  }, [calendarData]);

  useEffect(() => {
    if (selectedEvent) {
      setSelectedEvent(() => ({
        ...selectedEvent,
        ora: ora !== "" ? ora : selectedEvent.ora,
        tipoAgenda: tipoAgenda !== "" ? tipoAgenda : selectedEvent.tipoAgenda,
        data: data !== "" ? data : selectedEvent.data,
        durata: tempDurata,
      }));
    }
  }, [tempDurata]);

  // Evento invocato alla chiusura del modale di riepilogo e delle varie funzioni di ripristino ad uno stato di default di una view
  const handleSummaryClose = () => {
    setOpenSummary(false);
    onBookingComplete();
    handleReset();
    handleResetForm();
    setAccordion(true);
    handleScrollReset();
    context?.clearAppointmentsList();
    context?.setEnte("");
    context?.setRegionDataHints({});
    context?.setRegionDataQueue?.([]);
  };

  // Evento invocato alla selezione della casistica di inserimento di un ciclo di prenotazioni
  const handleCiclingAppointments = () => {
    // console.log("CHIAMATO handleCiclingAppointments");
    handleAppointmentSubmit(1);
    onBookingComplete();
    setAccordion(true);
    handleScrollReset();
    setSearchSubmit(false);
  };

  // Evento invocato alla selezione della casistica di inserimento di un'altra prestazione in una prenotazione
  const handleMultipleAppointments = () => {
    // console.log("CHIAMATO handleMultipleAppointments");
    handleAppointmentSubmit(2);
    onBookingComplete();
    setAccordion(true);
    handleScrollReset();
    setSearchSubmit(false);
    context?.setEnte(ente);
  };

  const calendarRef = useRef<FullCalendar | null>(null);

  // funzione per gestire l'evento al click sull'orario dell'appuntamento se la finestra è in modalità gestione sospesi,
  // salvando i dati in uno state contenente la lista delle ore disponibili
  const handleClickForDaysDataHandlingGestioneSospesi = (data: any) => {
    setListaOrariDettaglio([]);
    const calendarApi = calendarRef.current?.getApi();
    const clickedDate = data.event.start;

    if (!calendarApi || !clickedDate) return;

    const allEvents = calendarApi.getEvents();

    const clickedDateStr = clickedDate.toISOString().split("T")[0];

    // Recupera tutti gli eventi che iniziano in quel giorno
    const eventsOfDay = allEvents.filter((event) => {
      const eventDateStr = event.start?.toISOString().split("T")[0];
      return eventDateStr === clickedDateStr;
    });

    const orariFormattati: FormatGrigliaOrariPerGestioneSospesi[] = eventsOfDay
      .filter((e) => e.extendedProps?.ora)
      .map((e) => ({
        data: dayjs(e.startStr).format(`DD/MM/YYYY`),
        ora: e.extendedProps.ora,
        medico: e.extendedProps.nominativoMedico ?? "",
        codiceMedico: e.extendedProps.medicoId ?? "",
      }));
    setListaOrariDettaglio((prev: FormatGrigliaOrariPerGestioneSospesi[]) => [
      ...prev,
      ...orariFormattati,
    ]);
  };

  //#region Props oggetto states passati per le options selezionabili
  const propsOpzioniGiornaliere = {
    calendarInfo,
    showOptionNoteGiornaliere,
    setShowOptionNoteGiornaliere,
    showOptionOrarioGiornaliero,
    setShowOptionOrarioGiornaliero,
    showOptionCancellazioneOrarioGiornaliero,
    setShowOptionCancellazioneOrarioGiornaliero,
    showOptionInserireIndisponibilita,
    setShowOptionInserireIndisponibilita,
    dataGiornoSelezionato,
    setDataGiornoSelezionato,
    oggettoNotaSelezionato,
    setOggettoNotaSelezionato,
    onBookingComplete,
    setMessage,
    setSeverity,
    setShowAllert,
    setFn,
  };

  const propsNotePopUp = {
    showPopupNote,
    setShowPopupNote,
    handleEventClick,
    setShowPrestazioniCombinateModal,
    dataSlot,
    popupNoteMessage,
  };
  //#endregion

  //Per gestire la conferma delle prestazioni raggruppate
  const handleGroupableConfirm = (payload: Record<string, string>) => {
    setGroupableOpen(false);

    // salva payload per wParaggr (lo usiamo dopo in postAppointmentData)
    context?.setGroupableProceduresPayload(payload);

    // apro il modale di compilazione prenotazione
    setTimeout(() => setOpen(true), 0);
  };

  return (
    <>
      <GroupableProcedures
        open={groupableOpen}
        onConfirm={handleGroupableConfirm}
        onClose={() => {
          setGroupableOpen(false);
          setOpen(true);
        }}
        procedures={groupableProcedures ?? []}
        aziendaPrenotazione={
          selectedEvent?.struttura ?? calendarInfo.aziendaPrenotazione ?? ""
        }
        idPacada={idPacadaProcedure}
        groupingHeader={groupingHeader ?? { tipo: "", descr: "" }}
      />
      <CombinedProcedures
        open={showPrestazioniCombinateModal}
        onClose={() => {
          setShowPrestazioniCombinateModal(false);
          handleAppointmentAbort("Prenotazione annullata");
        }}
        onConfirm={(_selected) => {
          setOpen(true);
          setShowPrestazioniCombinateModal(false);
        }}
        rows={combinedProcedures}
        idPacada={idPacadaProcedure}
      />
      <AllertMessage
        showAllert={showAllert}
        setShowAllert={setShowAllert}
        severity={severity}
        message={message}
        submitFunction={fn}
      />
      <ModalReservationSummaryNew
        openSummary={openSummary}
        onCloseSummary={handleSummaryClose}
        summaryData={summaryData}
        appointmentDetails={appointmentDetails}
        showRegionDataDetail={showRegionDataDetail}
        setShowRegionDataDetail={setShowRegionDataDetail}
        // [REG] Al click su “Chiudi/Salva” dei Dati Regionali avanza la coda
        onRegionDataClose={handleRegionDataClose}
      />
      <NotePopUp {...propsNotePopUp} />

      <DailyUnavailability {...propsOpzioniGiornaliere} />

      {dataGiornoSelezionato && (
        <DailyNoteOption
          {...propsOpzioniGiornaliere}
          //Una volta inserita una nuova nota giornaliera richiamo la fetch per visualizzare tutte le note
          onNoteSaved={() => {
            refreshVisibleRangeNotes({ force: true });
          }}
        />
      )}
      <ModalReservation
        open={open}
        onClose={handleClose}
        onTimeout={handleTimeOut}
        onAppointmentAbort={handleAppointmentAbort}
        handleSummary={handleAppointmentSubmit}
        handleCicles={handleCiclingAppointments}
        handleMultiplePrestazioni={handleMultipleAppointments}
        bookingResponse={bookingResponse}
        selectedEvent={selectedEvent}
        durata={durata}
        setDurata={setDurata}
        tempDurata={tempDurata}
        setTempDurata={setTempDurata}
        idPaziente={idPaziente}
        setIdPaziente={setIdPaziente}
        data={data}
        setData={setData}
        ora={ora}
        setOra={setOra}
        tipoAgenda={tipoAgenda}
        setTipoAgenda={setTipoAgenda}
        nomePaziente={nomePaziente}
        setNomeField={setNome}
        cognomePaziente={cognomePaziente}
        setCognomeField={setCognome}
        dataNascita={dataNascita}
        setDataNascitaField={setDataNascita}
        codiceFiscale={codiceFiscale}
        setCodiceFiscaleField={setCodiceFiscale}
        numeroTelefono={numeroTelefono}
        setNumeroTelefono={setNumeroTelefono}
        email={email}
        setEmail={setEmail}
        posizioneTicket={posizioneTicket}
        setPosizioneTicket={setPosizioneTicket}
        classePriorita={classePriorita}
        setClassePriorita={setClassePriorita}
        numeroImpegnativa={numeroImpegnativa}
        setNumeroImpegnativa={setNumeroImpegnativa}
        dataImpegnativa={dataImpegnativa}
        setDataImpegnativa={setDataImpegnativa}
        ente={ente}
        setEnte={setEnte}
        numeroTessera={numeroTessera}
        setNumeroTessera={setNumeroTessera}
        suggerita={suggerita}
        setSuggerita={setSuggerita}
        primoAccesso={primoAccesso}
        setPrimoAccesso={setPrimoAccesso}
        tipoCalcolo={tipoCalcolo}
        setTipoCalcolo={setTipoCalcolo}
        note={note}
        setNote={setNote}
        distrettoNote={distrettoNote}
        setDistrettoNote={setDistrettoNote}
        diagnosiNote={diagnosiNote}
        setDiagnosiNote={setDiagnosiNote}
        prioritaNote={prioritaNote}
        setPrioritaNote={setPrioritaNote}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleReset={handleReset}
        rowsEntiData={rowsEntiData}
        rowsPosizioneTicketData={rowsPosizioneTicketData}
        posizioneTicketDataByPrenotazione={posizioneTicketDataByPrenotazione}
        rowsClassePrioritaData={rowsClassePrioritaData}
        // handleCancellation={handleCancellation}
        descrizionePrestazione={selectedEvent?.descrizionePrestazione}
        descrizioneSpecialita={selectedEvent?.descrizioneSpecialita}
        descrizioneTipoAgenda={selectedEvent?.descrizioneTipoAgenda}
      />

      <Box
        className="calendar-container"
        sx={{ maxHeight: "425px", minHeight: "425px" }}
      >
        <Box
          className="card-container"
          sx={{ maxHeight: "100%", minHeight: "100%", maxWidth: "220px" }}
        >
          {Object.keys(doctorsMap).map((medicoId) => {
            const doctorEvents = doctorsMap[medicoId];
            const doctorInfo = doctorEvents[0];

            return (
              <DoctorCard
                key={id}
                doctorInfo={doctorInfo}
                medicoId={medicoId}
                doctorImage={id % 2 === 0 ? doctorImage : doctorImage2}
              />
            );
          })}
        </Box>

        <Box
          className="calendar calendar-scroller"
          ref={containerRef}
          sx={{
            ".fc-col-header-cell": { padding: "10px", overflow: "visible" },
            ".fc-col-header": { overflow: "visible" },
            ".fc-scrollgrid": { overflow: "visible" },
            ".fc-scroller": { overflowX: "auto !important" },
            ".fc-media-screen": { flexDirection: "row" },
          }}
        >
          <FullCalendar
            datesSet={(arg) => {
              const dataIni = dayjs(arg.start).format("YYYY-MM-DD");
              const dataFin = dayjs(arg.end)
                .subtract(1, "day")
                .format("YYYY-MM-DD");
              fetchNotesForRange(dataIni, dataFin);
            }}
            schedulerLicenseKey="0733783808-fcs-1733393302"
            ref={calendarRef}
            height={"100px"}
            locale={itLocale}
            dayMinWidth={120}
            views={{
              DayHeader: {},
              dayGridWeek: {
                duration: { days: giorni + 1 },
                dayMinWidth: 120,
              },
            }}
            plugins={[dayGridPlugin, scrollGridPlugin]}
            initialView="dayGridWeek" // Usa "dayGridWeek" per lo scroll orizzontale
            initialDate={initialDate}
            events={memoizedEvents}
            eventContent={renderEventContent}
            eventClick={(info) => {
              if (modalitaSospesi.state) {
                handleClickForDaysDataHandlingGestioneSospesi(info);
                setModalitaSospesi((prev: ModalitaSospesi) => ({
                  ...prev,
                  view: true,
                }));
              } else {
                handleNotePopup(info);
                // console.log("GUARDA QUA", info.event);
                // console.log("GET WEEK EVENT", getWeekdayFromEvent(info));

                // handleEventClick(info);
              }
            }}
            headerToolbar={{
              start: "",
              center: "",
              end: "",
            }}
            footerToolbar={{
              start: "",
              center: "",
              end: "",
            }}
            dayHeaderClassNames="testStile"
            dayCellDidMount={(info) => {
              // console.log("info", info);
              // console.log("info el", info.el);

              if (info.date.getDay() === 0) {
                info.el.style.position = "relative";
                info.el.style.setProperty("padding", "0");
                info.el.style.setProperty("background-color", "transparent");

                const rect = document.createElement("div");
                rect.style.position = "absolute";
                rect.style.top = "10px";
                rect.style.bottom = "10px";
                rect.style.left = "10px";
                rect.style.right = "10px";
                rect.style.backgroundColor = "#FDE1E1";
                rect.style.borderRadius = "2px";

                info.el.appendChild(rect);
              }
            }}
            dayHeaderContent={dayHeaderContent}
            eventTimeFormat={{
              hour: "numeric",
              minute: "2-digit",
              omitZeroMinute: false,
              meridiem: false,
            }}
            eventClassNames={(arg) => {
              if (arg.event.extendedProps.flagOrarioGiornaliero !== "N")
                return ["evento-giornaliero"];
              return [];
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Calendar;
